// extracted by mini-css-extract-plugin
export default {"classroomContainer":"Classroom_classroomContainer__u9IP1","centeredContainer":"Classroom_centeredContainer__QNOnh"};